import {runInAction} from 'mobx';
import {WizardLeftBarController} from '../invite-new/left-bar/controller';
import {WizardSectionTypes} from '../../layouts/main-layout/left-bar-base/controller';
import {GeneralSettings} from '../../models/AccountSettings';
import {IAgentInfoController} from '../../layouts/main-layout/agent-info-menu/controller';
import {IAccountSwitchController} from '../../layouts/main-layout/account-switch/controller';
import {ITranslate} from '../../services/LocalizationService';
import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';
import {ITsReactStateHelper} from '../../services/ts-react-state-helper/ts-react-state-helper.service';
import {RouteName} from '../../router/route-names';

export class HistoryConsoleLeftBarController extends WizardLeftBarController {
    constructor(
        translate: ITranslate,
        environmentService: ITsEnvironmentDetect,
        settings: GeneralSettings,
        currentUser: any,
        agentInfoCtrl: IAgentInfoController,
        accountSwitchCtrl: IAccountSwitchController,
        private readonly _stateHelper: ITsReactStateHelper
    ) {
        super(translate, environmentService, settings, currentUser, agentInfoCtrl, accountSwitchCtrl);

        // Keep only the invite icon — user is already on the history console page
        runInAction(() => {
            this._leftBarSections = this._leftBarSections.filter(
                (section) => section.sectionType === WizardSectionTypes.INVITE
            );
        });

        // Wire the invite icon to navigate back to the invite page
        this.executeItem(
            (item) => item.uid === 'invite',
            (section) => section.sectionType === WizardSectionTypes.INVITE,
            (item) => {
                item.onItemClicked = () => {
                    void this._stateHelper.navigateTo(RouteName.INVITE);
                };
            }
        );
    }
}
